import type { ForwardedRef } from "react";
import type { ChatTask } from "@/sdk/agent/chat";
import { AgentJoinedSeparator } from "./ListSeparators/AgentJoinedSeparator";
import { AutopilotActiveSeparator } from "./ListSeparators/AutopilotActiveSeparator";
import { ChatEndedSeparator } from "./ListSeparators/ChatEndedSeparator";
import type { SeparatorSubType } from "./useMessageListItems";

export function renderSeparator(
    separatorType: SeparatorSubType,
    chatTask: ChatTask,
    ref: ForwardedRef<HTMLDivElement>,
    idx: number,
) {
    const key = `${separatorType}-separator-${idx}`;
    switch (separatorType) {
        case "agent-joined":
            return <AgentJoinedSeparator key={key} chatTask={chatTask} ref={ref} />;
        case "autopilot-active":
            return <AutopilotActiveSeparator key={key} ref={ref} />;
        case "chat-ended":
            return <ChatEndedSeparator key={key} chatTask={chatTask} ref={ref} />;
        default:
            return null;
    }
}
